import { Box, Heading, Stack, Text } from 'braid-design-system';

import * as styles from './CalendarEventCard.css';

interface CalendarEventCardProps {
  title: string;
  date: string;
  image?: string;
  onClick: () => void;
}

export const CalendarEventCard = ({
  title,
  date,
  image,
  onClick,
}: CalendarEventCardProps) => (
  <Box
    component="button"
    type="button"
    cursor="pointer"
    onClick={onClick}
    display="block"
    width="full"
    height="full"
    padding="none"
    borderRadius="large"
    boxShadow="borderNeutralLight"
    background="body"
    className={styles.card}
  >
    <Box background="neutralLight" className={styles.imageFrame}>
      {image ? <img src={image} alt="" className={styles.image} /> : null}
    </Box>
    <Box padding="medium">
      <Stack space="small">
        <Heading level="4">{title}</Heading>
        <Text tone="secondary" size="small">
          {date}
        </Text>
      </Stack>
    </Box>
  </Box>
);
